// @generated by protoc-gen-es v1.7.2
// @generated from file penumbra/core/component/funding/v1/funding.proto (package penumbra.core.component.funding.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Amount } from "../../../num/v1/num_pb.js";

/**
 * Funding component configuration data.
 *
 * @generated from message penumbra.core.component.funding.v1.FundingParameters
 */
export const FundingParameters = proto3.makeMessageType(
  "penumbra.core.component.funding.v1.FundingParameters",
  [],
);

/**
 * Genesis data for the funding component.
 *
 * @generated from message penumbra.core.component.funding.v1.GenesisContent
 */
export const GenesisContent = proto3.makeMessageType(
  "penumbra.core.component.funding.v1.GenesisContent",
  () => [
    { no: 1, name: "funding_params", kind: "message", T: FundingParameters },
  ],
);

/**
 * Indicates that a funding stream reward was paid.
 *
 * @generated from message penumbra.core.component.funding.v1.EventFundingStreamReward
 */
export const EventFundingStreamReward = proto3.makeMessageType(
  "penumbra.core.component.funding.v1.EventFundingStreamReward",
  () => [
    { no: 1, name: "recipient", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "epoch_index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "reward_amount", kind: "message", T: Amount },
  ],
);

